import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';
import { useNavigate } from 'react-router-dom';
import Loading from '../components/Loading';

import photo1 from '../img/projects/wecollective/PHOTO1.jpg';
import photo2 from '../img/projects/wecollective/PHOTO2.jpg';
import photo3 from '../img/projects/wecollective/PHOTO3.jpg';
import photo4 from '../img/projects/wecollective/PHOTO4.jpg';
import photo5 from '../img/projects/wecollective/PHOTO5.jpg';

import img1 from '../img/projects/wecollective/img1.JPG';
import img2 from '../img/projects/wecollective/img2.JPG';
import img3 from '../img/projects/wecollective/img3.JPG';
import img4 from '../img/projects/wecollective/img4.JPG';
import img5 from '../img/projects/wecollective/img5.JPG';
import img6 from '../img/projects/wecollective/img6.JPG';

const Works = () => {

  const navigate = useNavigate()
  const edition1 = [
    { src: photo1, tags: ["WeCollective", "Vertical"] },
    { src: photo3, tags: ["WeCollective", "Vertical"] },
    { src: photo4, tags: ["WeCollective", "Vertical"] },
    { src: photo5, tags: ["WeCollective", "Vertical"] },
  ];

  const edition2 = [
    { src: img1, tags: ["WeCollective", "Vertical"] },
    { src: img2, tags: ["WeCollective", "Vertical"] },
    { src: img3, tags: ["WeCollective", "Vertical"] },
    { src: img4, tags: ["WeCollective", "Vertical"] },
    { src: img5, tags: ["WeCollective", "Vertical"] },
    { src: img6, tags: ["WeCollective", "Vertical"] },
  ];

  const [activeProject, setActiveProject] = useState("Edition 1");
  const [works, setWorks] = useState(edition1);
  const [directionFiltered, setDirectionFiltered] = useState(edition1);
  const [activeDirection, setActiveDirection] = useState('Both');
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 12;

  useEffect(() => {
    const selectedWorks = activeProject === "Edition 1" ? edition1 : edition2;
    setWorks(selectedWorks);
    if (activeDirection === 'Both') {
      setDirectionFiltered(selectedWorks);
    } else {
      setDirectionFiltered(selectedWorks.filter(work => work.tags.includes(activeDirection)));
    }
  }, [activeProject]);

  const handleDirection = (dir) => {
    setActiveDirection(dir);
    setCurrentPage(1);
    if (dir === 'Both') {
      setDirectionFiltered(works);
    } else {
      setDirectionFiltered(works.filter(work => work.tags.includes(dir)));
    }
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = directionFiltered.slice(indexOfFirstPost, indexOfLastPost);
  const paginate = (number) => setCurrentPage(number);

  if (!works || works.length === 0) return <h1 className='h1'><Loading /></h1>;

  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='lg:pt-32 overflow-auto pt-32 mb-44 lg:mb-0'
    >
      
      <div className='container mx-auto h-full relative px-4'>
        <div
        onClick={() => navigate("/album")}
            className="mb-10 lg:mb-0 text-center hover:scale-110 bg-zinc-900 text-gray-300 hover:text-white w-fit p-4 hover:cursor-pointer"
            >
         Back to Gallery
        </div>
        {/* Edition Tabs */}
        <div className='flex flex-col sm:flex-row sm:justify-center sm:items-center gap-4 sm:gap-8 py-4 border-2 border-zinc-900 rounded-2xl w-fit mx-auto px-6'>
          <div 
            onClick={() => setActiveProject("Edition 1")} 
            className={`cursor-pointer hover:text-black h6 px-4 ${activeProject === "Edition 1" ? 'text-black' : 'text-gray-500'}`}>
            Edition 1
          </div>
          <div 
            onClick={() => setActiveProject("Edition 2")} 
            className={`cursor-pointer hover:text-black h6 px-4 ${activeProject === "Edition 2" ? 'text-black' : 'text-gray-500'}`}>
            Edition 2
          </div>
        </div>

      

        {/* Image Grid */}
        <div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 py-10'>
          {currentPosts.map((work, index) => (
            <div key={index} className='w-full max-w-[340px] mx-auto'>
              <img
                onClick={() => window.open(work.src)}
                className='object-cover w-full h-full hover:scale-105 transition-transform duration-300 cursor-pointer'
                src={work.src}
                alt={`work-${index}`}
              />
            </div>
          ))}
        </div>

        {/* Optional Pagination (Uncomment if needed) */}
        {/* <Pagination
          postsPerPage={postsPerPage}
          totalPosts={directionFiltered.length}
          paginate={paginate}
          currentPage={currentPage}
        /> */}
      </div>
    </motion.section>
  );
};

export default Works;
